import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { WifiOff } from "lucide-react";

export default function OfflineIndicator() {
  const [offline, setOffline] = useState(() => typeof navigator !== "undefined" && !navigator.onLine);
  const wasOffline = useRef(offline);

  useEffect(() => {
    const goOffline = () => {
      wasOffline.current = true;
      setOffline(true);
    };
    const goOnline = () => {
      setOffline(false);
      if (wasOffline.current) {
        wasOffline.current = false;
        toast.success("Back online");
      }
    };
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      data-testid="offline-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-2.5 rounded-full border border-destructive/30 bg-destructive px-4 py-2.5 text-sm font-medium text-destructive-foreground shadow-lg"
    >
      <WifiOff className="h-4 w-4 shrink-0" />
      You're offline — you can keep working; changes will save when you reconnect.
    </div>
  );
}
